import { DatePicker, Form, Input, InputNumber } from 'antd';
import React from 'react';

import { FORMAT_DATE_DATEPICKER } from '../const';
import { FilterDropdownType, FormFilterConditionType } from '../types';

const { RangePicker } = DatePicker;

interface IInputWithValue {
    item: FilterDropdownType;
}

const InputForFilters: React.FC<IInputWithValue> = ({ item }) => {
    switch (item.inputType) {
        case 'List':
            return (
                <div style={{ width: 200 }}>
                    <Form.Item<FormFilterConditionType>
                        key={item.key}
                        name={item.key}
                        rules={[{ required: true, message: 'Please select item from list' }]}
                    >
                        {item.filterParams?.filterComponent}
                    </Form.Item>
                </div>
            );
        case 'Int':
            return (
                <>
                    {item.key === 'between' ? (
                        <>
                            <Form.Item<FormFilterConditionType> key={item.key + 1} name={`${item.key}1`}>
                                <InputNumber min={1} max={10000} placeholder={`value for ${item.label}`} />
                            </Form.Item>
                            <Form.Item<FormFilterConditionType> key={item.key + 2} name={`${item.key}2`}>
                                <InputNumber min={1} max={10000} placeholder={`value for ${item.label}`} />
                            </Form.Item>
                        </>
                    ) : (
                        <Form.Item<FormFilterConditionType> key={item.key} name={item.key}>
                            <InputNumber min={1} max={10000} placeholder={`value for ${item.label}`} />
                        </Form.Item>
                    )}
                </>
            );
        case 'Date':
            return (
                <>
                    {item.key === 'between' ? (
                        <Form.Item<FormFilterConditionType> key={item.key} name={item.key}>
                            <RangePicker />
                        </Form.Item>
                    ) : (
                        <Form.Item<FormFilterConditionType> key={item.key} name={item.key}>
                            <DatePicker style={{ width: '100%' }} format={FORMAT_DATE_DATEPICKER} />
                        </Form.Item>
                    )}
                </>
            );
        case 'String':
        default:
            return (
                <Form.Item<FormFilterConditionType> key={item.key} name={item.key}>
                    <Input placeholder={`value for ${item.label}`} />
                </Form.Item>
            );
    }
};

export default InputForFilters;
